module.exports = __webpack_public_path__ + "img/access-the-marketplace.b534fd93.png";